import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '欧美精品如何确保所售商品为正品？',
    answer: '我们与欧洲和美国的品牌官方及授权经销商直接合作，所有商品均来自正规渠道。每件商品附带完整的品牌包装、防伪标签和购物凭证，支持消费者前往品牌专柜进行验货。我们承诺假一赔十，请您放心选购。',
  },
  {
    question: '购买的欧美精品商品多久能收到？',
    answer: '根据商品库存情况，发货时间分为两种：国内保税仓现货商品下单后1-3个工作日发货；海外直邮商品需要7-15个工作日送达。所有订单均提供全程物流追踪，您可以随时查看包裹状态。',
  },
  {
    question: '欧美精品的退换货政策是怎样的？',
    answer: '我们提供7天无理由退换货服务。自签收之日起7天内，只要商品未经使用、包装完好、配件齐全，即可申请退换。部分特殊商品（如内衣、化妆品等）因卫生原因不支持退换，请在下单前仔细阅读商品详情页的退换说明。',
  },
  {
    question: '如何联系欧美精品的客服？',
    answer: '您可以通过以下方式联系我们的客服团队：服务热线 400-888-9999（工作日 9:00-21:00）、电子邮箱 service@oumeijingpin.com，或关注我们的微信公众号「欧美精品」在线咨询。我们的顾问团队将在第一时间为您提供专业服务。',
  },
  {
    question: '欧美精品支持哪些支付方式？',
    answer: '我们支持多种安全便捷的支付方式，包括：微信支付、支付宝、银联云闪付、以及Visa/Mastercard国际信用卡。所有支付均通过加密通道进行，确保您的资金安全。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于欧美精品的常见疑问，这里都有答案
          </p>
        </div>
        <div className="space-y-3">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{item.question}</span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-xs text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}